import { render, staticRenderFns } from "./category-panel-nav-bar.vue?vue&type=template&id=38c6ebf8&"
import script from "./category-panel-nav-bar.vue.ts?vue&type=script&lang=ts&"
export * from "./category-panel-nav-bar.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports